export enum ProductAllocationSlotTypeValue {
  DESIGN = "design",
  PRODUCTION = "production",
}
